/**
 * What is left of the design document's data.
 *
 * This was scaffolding for the whole Overview screen — `Summary`, `Holding[]`
 * and `ActivityEntry[]`, transcribed from `docs/design/Tesora - Desktop.html`
 * and typed as exactly what `WalletApi` returns, so that swapping in the live
 * call would be one line per view.
 *
 * **Those three are gone (#140).** `GET /v1/accounts/{account_ref}/balance`
 * and `GET /v1/transactions` landed (`go-wallet#972`, `#973`), Overview and
 * Payments read them, and the fixtures are DELETED rather than left
 * importable — an unused export that renders a whole wallet is one somebody
 * wires back up.
 *
 * What remains is the design's card and quote, which back panels nothing
 * serves yet, and the customer, which nothing reads. Each is a hazard of the
 * same kind and each is named where it is used.
 */

/** The signed-in customer, as the design's rail shows them. */
export const FIXTURE_CUSTOMER = {
  initials: 'MA',
  name: 'Mia Andersen',
  /** Verification tier, shown as the rail subtitle. */
  status: 'Personal · verified',
} as const

/**
 * The card tile.
 *
 * Invariant 13b: no cardholder data, anywhere. `maskedTail` is the last four
 * digits as the EMI's own PCI-compliant element reports them for display — it
 * is not a PAN, it is not derived from one, and nothing in this repo may ever
 * hold the other twelve digits.
 */
export const FIXTURE_CARD = {
  maskedTail: '4421',
  label: 'MA Studio',
  spentThisPeriod: { amountMinor: 84015n, currency: 'EUR' },
  /** Share of the period limit used, 0–1. Drives the design's 42% bar. */
  limitUsed: 0.42,
} as const
